import SubsectionCard from "../../WritingGradeSection/SubsectionCard";

const LinguisticCompetenceSection = ({ linguisticCompetence }) => {
  const accuracyAndGrammar = linguisticCompetence["accuracy_and_grammar"];
  const appropriatenessOfLanguage =
    linguisticCompetence["appropriateness_of_language"];
  const clarityOfCommunication =
    linguisticCompetence["clarity_of_communication"];
  const fluencyAndCoherence = linguisticCompetence["fluency_and_coherence"];

  return (
    <div className="writingGradeSectionContainer">
      <div className="writingGradeSectionHeaderContainer">
        <h2 className="writingGradeSectionHeader">
          Linguistic Competence - Score {linguisticCompetence.total}/40
        </h2>
      </div>
      <div className="writingGradeSectionBodyContainer">
        <div className="writingGradeSectionSubsectionWrapper">
          <SubsectionCard
            title={"Accuracy and Grammar"}
            score={`${accuracyAndGrammar.score}/10`}
            subTitle={"Comments"}
            subContent={accuracyAndGrammar.comments}
          />
          <SubsectionCard
            title={"Appropriateness of Language"}
            score={`${appropriatenessOfLanguage.score}/10`}
            subTitle={"Comments"}
            subContent={appropriatenessOfLanguage.comments}
          />
          <SubsectionCard
            title={"Clarity of Communication"}
            score={`${clarityOfCommunication.score}/10`}
            subTitle={"Comments"}
            subContent={clarityOfCommunication.comments}
          />
          <SubsectionCard
            title={"Fluency and Coherence"}
            score={`${fluencyAndCoherence.score}/10`}
            subTitle={"Comments"}
            subContent={fluencyAndCoherence.comments}
          />
        </div>
        <div className="writingGradeSectionScoreText">
          Score: {linguisticCompetence.total}/40
        </div>
      </div>
    </div>
  );
};

export default LinguisticCompetenceSection;
